import { watchEffect } from 'vue'
import {
  locales as localesDeepUiKit,
  setI18nLocale as setI18nLocaleDeepUiKit,
} from '@deepcloud/deep-ui-kit'
import {
  localeDE,
  localeEN,
  localeFR,
  localeIT,
  setI18nLocale as setI18nLocaleFieldValidators,
} from '@deepcloud/field-validators'
import { i18n } from '@/plugins/i18n'

// Add DeepUiKit locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localesDeepUiKit.de)
i18n.global.mergeLocaleMessage('fr', localesDeepUiKit.fr)
i18n.global.mergeLocaleMessage('it', localesDeepUiKit.it)
i18n.global.mergeLocaleMessage('en', localesDeepUiKit.en)

// Add DeepFieldValidators locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localeDE)
i18n.global.mergeLocaleMessage('fr', localeFR)
i18n.global.mergeLocaleMessage('it', localeIT)
i18n.global.mergeLocaleMessage('en', localeEN)

// update plugins i18n locale
watchEffect(() => {
  setI18nLocaleDeepUiKit(i18n.global.locale.value)
  setI18nLocaleFieldValidators(i18n.global.locale.value)
})
